import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectLanguageInCommonState } from 'app/app-state.index';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent  implements OnInit {
  language: any;
  showBanner: boolean = false;
  constructor(private store: Store<AppState>, private router: Router) {
   store.select(selectLanguageInCommonState).subscribe(language => {
      this.language = language;
    });
  }
  ngOnInit(): void {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      this.showBanner = true; // מראה את הבאנר אם עדיין לא הסכימו
    }
  }

  acceptCookies(): void {
    localStorage.setItem('cookiesAccepted', 'true');
    this.showBanner = false;
  }
}

